import { DefaultState, IState } from "./state";
import { KeysPost, TypesPost } from "./actions/types";
import { post, defaultPost } from '../../../model/post';

export const reducer = (state: IState = DefaultState(), action: TypesPost): IState => {
    switch (action.type) {
        case KeysPost.ADDPOST_REJECTED : {
            console.log("ADDPOST_REJECTED ", action.payload)
            return {
                ...state,
            }
        }
        case KeysPost.ADDPOST_FULFILLED: {
            console.log("ADDPOST_FULFILLED", action.payload)
            let post: post = action.payload;
            if (action.payload.result) {
                post = action.payload.result;
            }
            let posts: Array<post> = [...state.posts];
            let found = posts.findIndex(x => x._id === post._id);
            console.log("ADDPOST_FULFILLED FIND_INDEX:", found)
            if (found) {
                posts.push(post);
            }
            return {
                ...state,
                post: post,
                posts: posts,
            }
        }
        case KeysPost.LOADPOSTSUNDELIVERED_PENDING:
        case KeysPost.LOADPOSTSDELIVERED_PENDING: {
            return {
                ...state,
                posts: [],
                postsent: [],
                loadingposts: true,
            }
        }
        case KeysPost.LOADPOSTSUNDELIVERED_FULFILLED: {
            let q: Array<post> = action.payload;
            return {
                ...state,
                posts: q,
                loadingposts: false,
            }
        }
        case KeysPost.LOADPOSTSUNDELIVERED_REJECTED: {
            return {
                ...state,
                posts: [],
                loadingposts: false,
            }
        }
        case KeysPost.LOADPOSTSDELIVERED_FULFILLED: {
            return {
                ...state,
                postsent: action.payload,
                loadingposts: false,
            }
        }
        case KeysPost.LOADPOSTSDELIVERED_REJECTED: {
            return {
                ...state,
                postsent: [],
                loadingposts: false,
            }
        }
        case KeysPost.DELIVERYPOST_FULFILLED: {
            let ret: post = action.payload;
            let posts: Array<post> = [...state.posts];
            posts = posts.filter((post) => { return post._id !== ret._id });
            return {
                ...state,
                posts: posts,
                post: ret
            }
        }
        case KeysPost.DELIVERYPOST_REJECTED: {
            return {
                ...state
            }
        }
        case KeysPost.CHANGE_DESCRIPTION:
        case KeysPost.CHANGE_TITLE:
        case KeysPost.CHANGE_RTE:
        case KeysPost.CHANGE_ASSOCIATEDTAG:
        case KeysPost.CHANGE_YESNOQUESTION:
        case KeysPost.CHANGE_SURVEYTEXT:
            {
                let ret: post = { ...action.payload };
                return {
                    ...state,
                    post: ret
                }
            }


        case KeysPost.GETPOST_FULFILLED: {
            let ret: post = action.payload;
            return {
                ...state,
                post: ret
            }
        }
        case KeysPost.DELETEPOST_FULFILLED: {
            let id: string = action.payload;
            let posts = state.posts.filter(p => p._id !== id);

            return {
                ...state,
                posts: [...posts]
            }
        }
        case KeysPost.CLEAR_FIELDS: {
            let ret: post = action.payload;
            return {
                ...state,
                post: ret
            }
        }
        case KeysPost.LOADVOTES_FULFILLED: {
            const posts: post[] = [...state.postsent];
            const toAdd = posts.find(p => p._id === action.meta._id)
            toAdd.votes = [...action.payload];
            toAdd.loaded = true;
            return {
                ...state,
                postsent: posts
            }
        }
        case KeysPost.LOADVOTES_REJECTED: {
            return {
                ...state,
            }
        }
        case KeysPost.LOADVOTESTATS_FULFILLED: {
            const posts: post[] = [...state.postsent];
            const toAdd = posts.find(p => p._id === action.meta._id)
            toAdd.votestats = { ...action.payload };
            toAdd.loaded = true;
            return {
                ...state,
                postsent: posts
            }
        }
        case KeysPost.CHANGE_IMAGEBASE64: {
            return {
                ...state,
                post: {
                    ...action.payload
                }
            }
        }
        case KeysPost.NEWPOST: {
            return {
                ...state,
                post: { ...defaultPost() }
            }
        }
        case KeysPost.GETCONTENT_FULFILLED: {
            const posts: post[] = [...state.postsent];
            const toAdd = posts.find(p => p._id === action.meta._id)
            toAdd.htmlContent = action.payload.htmlContent;
            toAdd.imagebase64 = action.payload.imagebase64
            toAdd.loaded = true;
            return {
                ...state,
                postsent: posts
            }
        } default:
            return state;
    }
} 